import React from 'react';

const CopyIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" {...props}>
    <path
      d="M18 0H8C6.897 0 6 0.897 6 2V6H2C0.897 6 0 6.897 0 8V18C0 19.103 0.897 20 2 20H12C13.103 20 14 19.103 14 18V14H18C19.103 14 20 13.103 20 12V2C20 0.897 19.103 0 18 0ZM2 18V8H12L12.002 18H2ZM18 12H14V8C14 6.897 13.103 6 12 6H8V2H18V12Z"
      fill="url(#paint0_radial_2943_4554)"
    />
    <defs>
      <radialGradient
        id="paint0_radial_2943_4554"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(-3.9 12.7139) rotate(-5.74518) scale(32.9656)"
      >
        <stop stopColor="#8098F9" />
        <stop offset="0.49" stopColor="#C4BFF1" />
        <stop offset="1" stopColor="#8098F9" />
      </radialGradient>
    </defs>
  </svg>
);

export default CopyIcon;
